module.exports = __webpack_public_path__ + "65fe7ed5cb31038fc7bac508b82b2f8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/games/sm_image_mobile.jpg
// module id = 313
// module chunks = 0